import React from 'react';
import { useFocusRing } from '@react-aria/focus';
import clsx from 'clsx';

interface ErrorAlertAction {
    label: string;
    onClick: () => void;
}

interface ErrorAlertProps {
    message: string;
    action?: ErrorAlertAction;
    className?: string;
    'aria-live'?: 'polite' | 'assertive';
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ message, action, className, 'aria-live': ariaLive = 'polite' }) => {

    const { focusProps, isFocusVisible } = useFocusRing();

    return (
        <div role="alert" aria-live={ariaLive}
            className={clsx(
                'rounded-lg border px-4 py-3 w-full',
                'bg-red-50 border-red-200 text-red-800',
                className
            )}
        >
            <div className="flex items-start gap-2">
                <div className="flex-1">
                    <span className="text-sm">{message}</span>
                    {action && (
                        <>
                            {' '}
                            <button
                                {...focusProps}
                                onClick={action.onClick}
                                className={clsx(
                                    'bg-transparent inline text-sm font-medium underline transition-colors',
                                    'hover:text-red-900 focus:outline-none',
                                    isFocusVisible && 'ring-2 ring-red-500 ring-offset-2 rounded'
                                )}
                                type="button"
                            >
                                {action.label}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};